import { useEffect } from 'react';
export const Logout = () => {

	const endRadarSession = async () => {
		console.log('ending Radar session');
		if (localStorage.getItem('authorizationToken') != null) {
			const authToken = localStorage.getItem('authorizationToken') as string;
			try {
				const response = await fetch('/api/end-radar-session', {
					method: 'DELETE',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + authToken,
					},
				});

				if (response.ok) {
					console.log('Radar session ended successfully');

					// cleanup local storage
					localStorage.removeItem('user');
					localStorage.removeItem('contentDirectSession');
					localStorage.removeItem('globalContent');
					localStorage.removeItem('channelServices');
					localStorage.removeItem('partner');
					localStorage.removeItem('wifiBundle');
					localStorage.removeItem('sessionId');
					localStorage.removeItem('xerxesToken');
					localStorage.removeItem('authorizationToken');
					localStorage.removeItem('expireTime');
					console.log('logout susccessful');
					window.location.href = "/login";

				} else {
					console.error('Failed to end radar session:', response.status, response.statusText);
				}
			} catch (error) {
				console.error('Error:', error);
			}
		}
	};

	useEffect(() => {

		//End the radar session
		endRadarSession();
	}
		, []);

	return (
		<main className="main-content" role='main'>
			<section className="hero-component logged-in">
				<h2>Xfinity On Campus</h2>
				<p>Signing out please wait ...</p>
			</section>
		</main>
	)
}